import React from 'react';

import styles from "./TwoContent.module.scss";

export default function TwoContent({classname, block, animate = false, children}) {

    return (
        <div className={[styles.Main, classname ?? ''].join(' ')}>
            <div className={styles.Block}>{ block }</div>
            <div className={'size-6 pl-1'}>
                {children}
            </div>
        </div>
    )
}
